import { render, staticRenderFns } from "./MySelect.vue?vue&type=template&id=accea0ba&scoped=true&"
import script from "./MySelect.vue?vue&type=script&lang=js&"
export * from "./MySelect.vue?vue&type=script&lang=js&"
import style0 from "./MySelect.vue?vue&type=style&index=0&id=accea0ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accea0ba",
  null
  
)

export default component.exports